<script lang="ts" setup>
import { docsLink, blogLink, discordLink, twitterLink } from '@/app/data/links'
import { MainPages } from '@/types'
</script>

<template>
  <footer class="bg-gray-900 text-white pb-8 pt-10 xl:pb-14 xl:pt-12 font-neue">
    <div class="container mx-auto xl:flex flex-row justify-between">
      <AssetLogoText class="text-white w-full xl:w-[700px] h-auto" />

      <div
        class="xl:max-w-[420px] relative w-full max-xl:flex justify-between max-xl:mt-10 gap-20"
      >
        <div
          class="max-sm:flex sm:space-y-4 justify-between items-start w-full"
        >
          <div class="grid grid-cols-2 uppercase gap-2">
            <NuxtLink :to="{ name: MainPages.TermsOfUse }">
              <span class="text-white hover:text-green-500">
                {{ $t('home.footer.termsOfUse') }}
              </span>
            </NuxtLink>

            <NuxtLink :to="docsLink" target="_blank">
              <span class="text-white hover:text-green-500">
                {{ $t('home.docs') }}
              </span>
            </NuxtLink>

            <NuxtLink :to="{ name: MainPages.PrivacyPolicy }">
              <span class="text-white hover:text-green-500">
                {{ $t('home.footer.privacyPolicy') }}
              </span>
            </NuxtLink>

            <NuxtLink :to="blogLink" target="_blank">
              <span class="text-white hover:text-green-500">
                {{ $t('home.blog') }}
              </span>
            </NuxtLink>
          </div>

          <div class="flex space-x-4">
            <NuxtLink :to="discordLink" target="_blank">
              <AssetDiscord class="text-gray-600 hover:text-green-500" />
            </NuxtLink>

            <NuxtLink :to="twitterLink" target="_blank">
              <AssetTwitter class="text-gray-600 hover:text-green-500" />
            </NuxtLink>

            <!-- <NuxtLink :to="telegramLink" target="_blank">
              <AssetTelegram class="text-gray-600 hover:text-green-500" />
            </NuxtLink> -->
          </div>
        </div>

        <p
          class="xl:absolute bottom-0 leading-5 order-first max-w-[420px] max-sm:hidden w-full tracking-wide"
        >
          {{ $t('home.footer.description') }}
        </p>
      </div>
    </div>
  </footer>
</template>
